import React from "react";
import "./Loader.css";

interface LoaderProps {
  size?: number; // px
  color?: string; // gradient start color
  secondaryColor?: string; // gradient end color
  message?: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  size = 60,
  color = "#000000",
  secondaryColor = "#efefef",
  message,
  className = "",
}) => (
  <>
    <div className="modal-backdrop fade show bg-white opacity-75 z-1"></div>
    <div
      className={`w-100 h-100 position-fixed start-0 top-0 d-flex align-items-center justify-content-center z-2 ${className}`}
    >
       <div className="spinner-border  text-navy w-75px h-75px" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>

      {/* {message && <div className="loader-message ">{message}</div>} */}
    </div>
  </>
);

export default Loader;
